var _defineProperty = require("/var/www/html/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/var/www/html/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/var/www/html/node_modules/@babel/runtime/helpers/createClass.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
exports.ids = [1], exports.modules = {
  6: function _(e, t, r) {
    "use strict";

    r.r(t), r.d(t, "Headers", function () {
      return $;
    }), r.d(t, "Request", function () {
      return D;
    }), r.d(t, "Response", function () {
      return U;
    }), r.d(t, "FetchError", function () {
      return d;
    });
    var o = r(7),
      n = r(8),
      s = r(9),
      i = r(10),
      u = r(11);
    var a = o.Readable,
      l = Symbol("buffer"),
      c = Symbol("type");
    var f = /*#__PURE__*/function () {
      function f() {
        _classCallCheck(this, f);
        this[c] = "";
        var e = arguments[0],
          t = arguments[1],
          r = [];
        var o = 0;
        if (e) {
          var _t = e,
            _n = Number(_t.length);
          for (var _e = 0; _e < _n; _e++) {
            var _n2 = _t[_e];
            var _s = void 0;
            o += (_s = _n2 instanceof Buffer ? _n2 : ArrayBuffer.isView(_n2) ? Buffer.from(_n2.buffer, _n2.byteOffset, _n2.byteLength) : _n2 instanceof ArrayBuffer ? Buffer.from(_n2) : _n2 instanceof f ? _n2[l] : Buffer.from("string" == typeof _n2 ? _n2 : String(_n2))).length, r.push(_s);
          }
        }
        this[l] = Buffer.concat(r);
        var n = t && void 0 !== t.type && String(t.type).toLowerCase();
        n && !/[^\u0020-\u007E]/.test(n) && (this[c] = n);
      }
      return _createClass(f, [{
        key: "size",
        get: function get() {
          return this[l].length;
        }
      }, {
        key: "type",
        get: function get() {
          return this[c];
        }
      }, {
        key: "text",
        value: function text() {
          return Promise.resolve(this[l].toString());
        }
      }, {
        key: "arrayBuffer",
        value: function arrayBuffer() {
          var e = this[l],
            t = e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
          return Promise.resolve(t);
        }
      }, {
        key: "stream",
        value: function stream() {
          var e = new a();
          return e._read = function () {}, e.push(this[l]), e.push(null), e;
        }
      }, {
        key: "toString",
        value: function toString() {
          return "[object Blob]";
        }
      }, {
        key: "slice",
        value: function slice() {
          var e = this.size,
            t = arguments[0],
            r = arguments[1];
          var o, n;
          o = void 0 === t ? 0 : t < 0 ? Math.max(e + t, 0) : Math.min(t, e), n = void 0 === r ? e : r < 0 ? Math.max(e + r, 0) : Math.min(r, e);
          var s = Math.max(n - o, 0),
            i = this[l].slice(o, o + s),
            u = new f([], {
              type: arguments[2]
            });
          return u[l] = i, u;
        }
      }]);
    }();
    function d(e, t, r) {
      Error.call(this, e), this.message = e, this.type = t, r && (this.code = this.errno = r.code), Error.captureStackTrace(this, this.constructor);
    }
    var h;
    Object.defineProperties(f.prototype, {
      size: {
        enumerable: !0
      },
      type: {
        enumerable: !0
      },
      slice: {
        enumerable: !0
      }
    }), Object.defineProperty(f.prototype, Symbol.toStringTag, {
      value: "Blob",
      writable: !1,
      enumerable: !1,
      configurable: !0
    }), d.prototype = Object.create(Error.prototype), d.prototype.constructor = d, d.prototype.name = "FetchError";
    try {
      h = require("encoding").convert;
    } catch (e) {}
    var p = Symbol("Body internals"),
      b = o.PassThrough;
    function y(e) {
      var t = this,
        r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = r.size;
      var s = void 0 === n ? 0 : n;
      var i = r.timeout;
      var u = void 0 === i ? 0 : i;
      null == e ? e = null : g(e) ? e = Buffer.from(e.toString()) : w(e) || Buffer.isBuffer(e) || ("[object ArrayBuffer]" === Object.prototype.toString.call(e) ? e = Buffer.from(e) : ArrayBuffer.isView(e) ? e = Buffer.from(e.buffer, e.byteOffset, e.byteLength) : e instanceof o || (e = Buffer.from(String(e)))), this[p] = {
        body: e,
        disturbed: !1,
        error: null
      }, this.size = s, this.timeout = u, e instanceof o && e.on("error", function (e) {
        var r = "AbortError" === e.name ? e : new d("Invalid response body while trying to fetch ".concat(t.url, ": ").concat(e.message), "system", e);
        t[p].error = r;
      });
    }
    function m() {
      var e = this;
      if (this[p].disturbed) return y.Promise.reject(new TypeError("body used already for: ".concat(this.url)));
      if (this[p].disturbed = !0, this[p].error) return y.Promise.reject(this[p].error);
      var t = this.body;
      if (null === t) return y.Promise.resolve(Buffer.alloc(0));
      if (w(t) && (t = t.stream()), Buffer.isBuffer(t)) return y.Promise.resolve(t);
      if (!(t instanceof o)) return y.Promise.resolve(Buffer.alloc(0));
      var r = [],
        n = 0,
        s = !1;
      return new y.Promise(function (o, i) {
        var u;
        e.timeout && (u = setTimeout(function () {
          s = !0, i(new d("Response timeout while trying to fetch ".concat(e.url, " (over ").concat(e.timeout, "ms)"), "body-timeout"));
        }, e.timeout)), t.on("error", function (t) {
          "AbortError" === t.name ? (s = !0, i(t)) : i(new d("Invalid response body while trying to fetch ".concat(e.url, ": ").concat(t.message), "system", t));
        }), t.on("data", function (t) {
          if (!s && null !== t) {
            if (e.size && n + t.length > e.size) return s = !0, void i(new d("content size at ".concat(e.url, " over limit: ").concat(e.size), "max-size"));
            n += t.length, r.push(t);
          }
        }), t.on("end", function () {
          if (!s) {
            clearTimeout(u);
            try {
              o(Buffer.concat(r, n));
            } catch (t) {
              i(new d("Could not create Buffer from response body for ".concat(e.url, ": ").concat(t.message), "system", t));
            }
          }
        });
      });
    }
    function g(e) {
      return "object" == typeof e && "function" == typeof e.append && "function" == typeof e.delete && "function" == typeof e.get && "function" == typeof e.getAll && "function" == typeof e.has && "function" == typeof e.set && ("URLSearchParams" === e.constructor.name || "[object URLSearchParams]" === Object.prototype.toString.call(e) || "function" == typeof e.sort);
    }
    function w(e) {
      return "object" == typeof e && "function" == typeof e.arrayBuffer && "string" == typeof e.type && "function" == typeof e.stream && "function" == typeof e.constructor && "string" == typeof e.constructor.name && /^(Blob|File)$/.test(e.constructor.name) && /^(Blob|File)$/.test(e[Symbol.toStringTag]);
    }
    function v(e) {
      var t,
        r,
        n = e.body;
      if (e.bodyUsed) throw new Error("cannot clone body after it is used");
      return n instanceof o && "function" != typeof n.getBoundary && (t = new b(), r = new b(), n.pipe(t), n.pipe(r), e[p].body = t, n = r), n;
    }
    function T(e) {
      return null === e ? null : "string" == typeof e ? "text/plain;charset=UTF-8" : g(e) ? "application/x-www-form-urlencoded;charset=UTF-8" : w(e) ? e.type || null : Buffer.isBuffer(e) ? null : "[object ArrayBuffer]" === Object.prototype.toString.call(e) ? null : ArrayBuffer.isView(e) ? null : "function" == typeof e.getBoundary ? "multipart/form-data;boundary=".concat(e.getBoundary()) : e instanceof o ? null : "text/plain;charset=UTF-8";
    }
    function S(e) {
      var t = e.body;
      return null === t ? 0 : w(t) ? t.size : Buffer.isBuffer(t) ? t.length : t && "function" == typeof t.getLengthSync && (t._lengthRetrievers && 0 == t._lengthRetrievers.length || t.hasKnownLength && t.hasKnownLength()) ? t.getLengthSync() : null;
    }
    y.prototype = {
      get body() {
        return this[p].body;
      },
      get bodyUsed() {
        return this[p].disturbed;
      },
      arrayBuffer: function arrayBuffer() {
        return m.call(this).then(function (e) {
          return e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
        });
      },
      blob: function blob() {
        var e = this.headers && this.headers.get("content-type") || "";
        return m.call(this).then(function (t) {
          return Object.assign(new f([], {
            type: e.toLowerCase()
          }), _defineProperty({}, l, t));
        });
      },
      json: function json() {
        var e = this;
        return m.call(this).then(function (t) {
          try {
            return JSON.parse(t.toString());
          } catch (t) {
            return y.Promise.reject(new d("invalid json response body at ".concat(e.url, " reason: ").concat(t.message), "invalid-json"));
          }
        });
      },
      text: function text() {
        return m.call(this).then(function (e) {
          return e.toString();
        });
      },
      buffer: function buffer() {
        return m.call(this);
      },
      textConverted: function textConverted() {
        var e = this;
        return m.call(this).then(function (t) {
          return function (e, t) {
            if ("function" != typeof h) throw new Error("The package `encoding` must be installed to use the textConverted() function");
            var r = t.get("content-type");
            var o,
              n,
              s = "utf-8";
            return r && (o = /charset=([^;]*)/i.exec(r)), n = e.slice(0, 1024).toString(), !o && n && (o = /<meta.+?charset=(['"])(.+?)\1/i.exec(n)), !o && n && (o = /<meta[\s]+?http-equiv=(['"])content-type\1[\s]+?content=(['"])(.+?)\2/i.exec(n)) && (o = /charset=(.*)/i.exec(o.pop())), !o && n && (o = /<\?xml.+?encoding=(['"])(.+?)\1/i.exec(n)), o && ("gb2312" !== (s = o.pop()) && "gbk" !== s || (s = "gb18030")), h(e, "UTF-8", s).toString();
          }(t, e.headers);
        });
      }
    }, Object.defineProperties(y.prototype, {
      body: {
        enumerable: !0
      },
      bodyUsed: {
        enumerable: !0
      },
      arrayBuffer: {
        enumerable: !0
      },
      blob: {
        enumerable: !0
      },
      json: {
        enumerable: !0
      },
      text: {
        enumerable: !0
      }
    }), y.mixIn = function (e) {
      var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(y.prototype)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          if (!(_t2 in e)) {
            var _r = Object.getOwnPropertyDescriptor(y.prototype, _t2);
            Object.defineProperty(e, _t2, _r);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }, y.Promise = global.Promise;
    var j = /[^\^_`a-zA-Z\-0-9!#$%&'*+.|~]/,
      O = /[^\t\x20-\x7e\x80-\xff]/;
    function E(e) {
      if (e = "".concat(e), j.test(e) || "" === e) throw new TypeError("".concat(e, " is not a legal HTTP header name"));
    }
    function P(e) {
      if (e = "".concat(e), O.test(e)) throw new TypeError("".concat(e, " is not a legal HTTP header value"));
    }
    function x(e, t) {
      t = t.toLowerCase();
      for (var _r2 in e) if (_r2.toLowerCase() === t) return _r2;
    }
    var B = Symbol("map");
    var $ = /*#__PURE__*/function () {
      function $() {
        _classCallCheck(this, $);
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
        if (this[B] = Object.create(null), e instanceof $) {
          var _t3 = e.raw(),
            _r3 = Object.keys(_t3);
          for (var _i = 0, _r4 = _r3; _i < _r4.length; _i++) {
            var _e2 = _r4[_i];
            var _iterator2 = _createForOfIteratorHelper(_t3[_e2]),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _r5 = _step2.value;
                this.append(_e2, _r5);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } else if (null == e) ;else {
          if ("object" != typeof e) throw new TypeError("Provided initializer must be an object");
          {
            var _t4 = e[Symbol.iterator];
            if (null != _t4) {
              if ("function" != typeof _t4) throw new TypeError("Header pairs must be iterable");
              var _r6 = [];
              var _iterator3 = _createForOfIteratorHelper(e),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _t5 = _step3.value;
                  if ("object" != typeof _t5 || "function" != typeof _t5[Symbol.iterator]) throw new TypeError("Each header pair must be iterable");
                  _r6.push(Array.from(_t5));
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              for (var _i2 = 0, _r7 = _r6; _i2 < _r7.length; _i2++) {
                var _e3 = _r7[_i2];
                if (2 !== _e3.length) throw new TypeError("Each header pair must be a name/value tuple");
                this.append(_e3[0], _e3[1]);
              }
            } else for (var _i3 = 0, _Object$keys = Object.keys(e); _i3 < _Object$keys.length; _i3++) {
              var _t6 = _Object$keys[_i3];
              var _r8 = e[_t6];
              this.append(_t6, _r8);
            }
          }
        }
      }
      return _createClass($, [{
        key: "get",
        value: function get(e) {
          E(e = "".concat(e));
          var t = x(this[B], e);
          return void 0 === t ? null : this[B][t].join(", ");
        }
      }, {
        key: "forEach",
        value: function forEach(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
            r = C(this),
            o = 0;
          for (; o < r.length;) {
            var n = r[o];
            var _s2 = n[0],
              _i4 = n[1];
            e.call(t, _i4, _s2, this), r = C(this), o++;
          }
        }
      }, {
        key: "set",
        value: function set(e, t) {
          t = "".concat(t), E(e = "".concat(e)), P(t);
          var r = x(this[B], e);
          this[B][void 0 !== r ? r : e] = [t];
        }
      }, {
        key: "append",
        value: function append(e, t) {
          t = "".concat(t), E(e = "".concat(e)), P(t);
          var r = x(this[B], e);
          void 0 !== r ? this[B][r].push(t) : this[B][e] = [t];
        }
      }, {
        key: "has",
        value: function has(e) {
          return E(e = "".concat(e)), void 0 !== x(this[B], e);
        }
      }, {
        key: "delete",
        value: function _delete(e) {
          E(e = "".concat(e));
          var t = x(this[B], e);
          void 0 !== t && delete this[B][t];
        }
      }, {
        key: "raw",
        value: function raw() {
          return this[B];
        }
      }, {
        key: "keys",
        value: function keys() {
          return A(this, "key");
        }
      }, {
        key: "values",
        value: function values() {
          return A(this, "value");
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return A(this, "key+value");
        }
      }]);
    }();
    function C(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "key+value";
      return Object.keys(e[B]).sort().map("key" === t ? function (e) {
        return e.toLowerCase();
      } : "value" === t ? function (t) {
        return e[B][t].join(", ");
      } : function (t) {
        return [t.toLowerCase(), e[B][t].join(", ")];
      });
    }
    $.prototype.entries = $.prototype[Symbol.iterator], Object.defineProperty($.prototype, Symbol.toStringTag, {
      value: "Headers",
      writable: !1,
      enumerable: !1,
      configurable: !0
    }), Object.defineProperties($.prototype, {
      get: {
        enumerable: !0
      },
      forEach: {
        enumerable: !0
      },
      set: {
        enumerable: !0
      },
      append: {
        enumerable: !0
      },
      has: {
        enumerable: !0
      },
      delete: {
        enumerable: !0
      },
      keys: {
        enumerable: !0
      },
      values: {
        enumerable: !0
      },
      entries: {
        enumerable: !0
      }
    });
    var L = Symbol("internal");
    function A(e, t) {
      var r = Object.create(k);
      return r[L] = {
        target: e,
        kind: t,
        index: 0
      }, r;
    }
    var k = Object.setPrototypeOf({
      next: function next() {
        if (!this || Object.getPrototypeOf(this) !== k) throw new TypeError("Value of `this` is not a HeadersIterator");
        var e = this[L];
        var t = e.target,
          r = e.kind,
          o = e.index,
          n = C(t, r);
        return o >= n.length ? {
          value: void 0,
          done: !0
        } : (this[L].index = o + 1, {
          value: n[o],
          done: !1
        });
      }
    }, Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]())));
    Object.defineProperty(k, Symbol.toStringTag, {
      value: "HeadersIterator",
      writable: !1,
      enumerable: !1,
      configurable: !0
    });
    var R = Symbol("Response internals"),
      z = n.STATUS_CODES;
    var U = /*#__PURE__*/function () {
      function U() {
        _classCallCheck(this, U);
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        y.call(this, e, t);
        var r = t.status || 200,
          o = new $(t.headers);
        if (null != e && !o.has("Content-Type")) {
          var _t7 = T(e);
          _t7 && o.append("Content-Type", _t7);
        }
        this[R] = {
          url: t.url,
          status: r,
          statusText: t.statusText || z[r],
          headers: o,
          counter: t.counter
        };
      }
      return _createClass(U, [{
        key: "url",
        get: function get() {
          return this[R].url || "";
        }
      }, {
        key: "status",
        get: function get() {
          return this[R].status;
        }
      }, {
        key: "ok",
        get: function get() {
          return this[R].status >= 200 && this[R].status < 300;
        }
      }, {
        key: "redirected",
        get: function get() {
          return this[R].counter > 0;
        }
      }, {
        key: "statusText",
        get: function get() {
          return this[R].statusText;
        }
      }, {
        key: "headers",
        get: function get() {
          return this[R].headers;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new U(v(this), {
            url: this.url,
            status: this.status,
            statusText: this.statusText,
            headers: this.headers,
            ok: this.ok,
            redirected: this.redirected
          });
        }
      }]);
    }();
    y.mixIn(U.prototype), Object.defineProperties(U.prototype, {
      url: {
        enumerable: !0
      },
      status: {
        enumerable: !0
      },
      ok: {
        enumerable: !0
      },
      redirected: {
        enumerable: !0
      },
      statusText: {
        enumerable: !0
      },
      headers: {
        enumerable: !0
      },
      clone: {
        enumerable: !0
      }
    }), Object.defineProperty(U.prototype, Symbol.toStringTag, {
      value: "Response",
      writable: !1,
      enumerable: !1,
      configurable: !0
    });
    var H = Symbol("Request internals"),
      _ = s.parse,
      q = s.format,
      F = ("destroy" in o.Readable.prototype);
    function I(e) {
      return "object" == typeof e && "object" == typeof e[H];
    }
    var D = /*#__PURE__*/function () {
      function D(e) {
        _classCallCheck(this, D);
        var t,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        I(e) ? t = _(e.url) : (t = e && e.href ? _(e.href) : _("".concat(e)), e = {});
        var o = r.method || e.method || "GET";
        if (o = o.toUpperCase(), (null != r.body || I(e) && null !== e.body) && ("GET" === o || "HEAD" === o)) throw new TypeError("Request with GET/HEAD method cannot have body");
        var n = null != r.body ? r.body : I(e) && null !== e.body ? v(e) : null;
        y.call(this, n, {
          timeout: r.timeout || e.timeout || 0,
          size: r.size || e.size || 0
        });
        var s = new $(r.headers || e.headers || {});
        if (null != n && !s.has("Content-Type")) {
          var _e4 = T(n);
          _e4 && s.append("Content-Type", _e4);
        }
        var i = I(e) ? e.signal : null;
        if ("signal" in r && (i = r.signal), null != i && !function (e) {
          var t = e && "object" == typeof e && Object.getPrototypeOf(e);
          return !(!t || "AbortSignal" !== t.constructor.name);
        }(i)) throw new TypeError("Expected signal to be an instanceof AbortSignal");
        this[H] = {
          method: o,
          redirect: r.redirect || e.redirect || "follow",
          headers: s,
          parsedURL: t,
          signal: i
        }, this.follow = void 0 !== r.follow ? r.follow : void 0 !== e.follow ? e.follow : 20, this.compress = void 0 !== r.compress ? r.compress : void 0 === e.compress || e.compress, this.counter = r.counter || e.counter || 0, this.agent = r.agent || e.agent;
      }
      return _createClass(D, [{
        key: "method",
        get: function get() {
          return this[H].method;
        }
      }, {
        key: "url",
        get: function get() {
          return q(this[H].parsedURL);
        }
      }, {
        key: "headers",
        get: function get() {
          return this[H].headers;
        }
      }, {
        key: "redirect",
        get: function get() {
          return this[H].redirect;
        }
      }, {
        key: "signal",
        get: function get() {
          return this[H].signal;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new D(this);
        }
      }]);
    }();
    function M(e) {
      Error.call(this, e), this.type = "aborted", this.message = e, Error.captureStackTrace(this, this.constructor);
    }
    y.mixIn(D.prototype), Object.defineProperty(D.prototype, Symbol.toStringTag, {
      value: "Request",
      writable: !1,
      enumerable: !1,
      configurable: !0
    }), Object.defineProperties(D.prototype, {
      method: {
        enumerable: !0
      },
      url: {
        enumerable: !0
      },
      headers: {
        enumerable: !0
      },
      redirect: {
        enumerable: !0
      },
      clone: {
        enumerable: !0
      },
      signal: {
        enumerable: !0
      }
    }), M.prototype = Object.create(Error.prototype), M.prototype.constructor = M, M.prototype.name = "AbortError";
    var G = o.PassThrough,
      N = s.resolve;
    function V(e, t) {
      if (!V.Promise) throw new Error("native promise missing, set fetch.Promise to your favorite alternative");
      return y.Promise = V.Promise, new V.Promise(function (r, s) {
        var a = new D(e, t),
          l = function (e) {
            var t = e[H].parsedURL,
              r = new $(e[H].headers);
            if (r.has("Accept") || r.set("Accept", "*/*"), !t.protocol || !t.hostname) throw new TypeError("Only absolute URLs are supported");
            if (!/^https?:$/.test(t.protocol)) throw new TypeError("Only HTTP(S) protocols are supported");
            if (e.signal && e.body instanceof o.Readable && !F) throw new Error("Cancellation of streamed requests with AbortSignal is not supported in node < 8");
            var n = null;
            if (null == e.body && /^(POST|PUT)$/i.test(e.method) && (n = "0"), null != e.body) {
              var _t8 = S(e);
              "number" == typeof _t8 && (n = String(_t8));
            }
            n && r.set("Content-Length", n), r.has("User-Agent") || r.set("User-Agent", "node-fetch/1.0 (+https://github.com/bitinn/node-fetch)"), e.compress && !r.has("Accept-Encoding") && r.set("Accept-Encoding", "gzip,deflate");
            var s = e.agent;
            return "function" == typeof s && (s = s(t)), r.has("Connection") || s || r.set("Connection", "close"), Object.assign({}, t, {
              method: e.method,
              headers: function (e) {
                var t = Object.assign({
                    __proto__: null
                  }, e[B]),
                  r = x(e[B], "Host");
                return void 0 !== r && (t[r] = t[r][0]), t;
              }(r),
              agent: s
            });
          }(a),
          c = ("https:" === l.protocol ? i : n).request,
          f = a.signal;
        var h = null;
        var p = function p() {
          var e = new M("The user aborted a request.");
          s(e), a.body && a.body instanceof o.Readable && a.body.destroy(e), h && h.body && h.body.emit("error", e);
        };
        if (f && f.aborted) return void p();
        var b = function b() {
            p(), g();
          },
          y = c(l);
        var m;
        function g() {
          y.abort(), f && f.removeEventListener("abort", b), clearTimeout(m);
        }
        f && f.addEventListener("abort", b), a.timeout && y.once("socket", function (e) {
          m = setTimeout(function () {
            s(new d("network timeout at: ".concat(a.url), "request-timeout")), g();
          }, a.timeout);
        }), y.on("error", function (e) {
          s(new d("request to ".concat(a.url, " failed, reason: ").concat(e.message), "system", e)), g();
        }), y.on("response", function (e) {
          clearTimeout(m);
          var t = function (e) {
            var t = new $();
            for (var _i5 = 0, _Object$keys2 = Object.keys(e); _i5 < _Object$keys2.length; _i5++) {
              var _r9 = _Object$keys2[_i5];
              if (!j.test(_r9)) if (Array.isArray(e[_r9])) {
                var _iterator4 = _createForOfIteratorHelper(e[_r9]),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _o = _step4.value;
                    O.test(_o) || (void 0 === t[B][_r9] ? t[B][_r9] = [_o] : t[B][_r9].push(_o));
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              } else O.test(e[_r9]) || (t[B][_r9] = [e[_r9]]);
            }
            return t;
          }(e.headers);
          if (V.isRedirect(e.statusCode)) {
            var _o2 = t.get("Location"),
              _n3 = null === _o2 ? null : N(a.url, _o2);
            switch (a.redirect) {
              case "error":
                return s(new d("redirect mode is set to error: ".concat(a.url), "no-redirect")), void g();
              case "manual":
                if (null !== _n3) try {
                  t.set("Location", _n3);
                } catch (e) {
                  s(e);
                }
                break;
              case "follow":
                if (null === _n3) break;
                if (a.counter >= a.follow) return s(new d("maximum redirect reached at: ".concat(a.url), "max-redirect")), void g();
                var _o3 = {
                  headers: new $(a.headers),
                  follow: a.follow,
                  counter: a.counter + 1,
                  agent: a.agent,
                  compress: a.compress,
                  method: a.method,
                  body: a.body,
                  signal: a.signal,
                  timeout: a.timeout
                };
                return 303 !== e.statusCode && a.body && null === S(a) ? (s(new d("Cannot follow redirect with body being a readable stream", "unsupported-redirect")), void g()) : (303 !== e.statusCode && (301 !== e.statusCode && 302 !== e.statusCode || "POST" !== a.method) || (_o3.method = "GET", _o3.body = void 0, _o3.headers.delete("content-length")), r(V(new D(_n3, _o3))), void g());
            }
          }
          e.once("end", function () {
            f && f.removeEventListener("abort", b);
          });
          var o = e.pipe(new G());
          var n = {
              url: a.url,
              status: e.statusCode,
              statusText: e.statusMessage,
              headers: t,
              size: a.size,
              timeout: a.timeout,
              counter: a.counter
            },
            i = t.get("Content-Encoding");
          if (!a.compress || "HEAD" === a.method || null === i || 204 === e.statusCode || 304 === e.statusCode) return h = new U(o, n), void r(h);
          var l = {
            flush: u.Z_SYNC_FLUSH,
            finishFlush: u.Z_SYNC_FLUSH
          };
          if ("gzip" == i || "x-gzip" == i) return o = o.pipe(u.createGunzip(l)), h = new U(o, n), void r(h);
          if ("deflate" != i && "x-deflate" != i) {
            if ("br" == i && "function" == typeof u.createBrotliDecompress) return o = o.pipe(u.createBrotliDecompress()), h = new U(o, n), void r(h);
            h = new U(o, n), r(h);
          } else e.pipe(new G()).once("data", function (e) {
            o = 8 == (15 & e[0]) ? o.pipe(u.createInflate()) : o.pipe(u.createInflateRaw()), h = new U(o, n), r(h);
          });
        }), function (e, t) {
          var r = t.body;
          null === r ? e.end() : w(r) ? r.stream().pipe(e) : Buffer.isBuffer(r) ? (e.write(r), e.end()) : r.pipe(e);
        }(y, a);
      });
    }
    V.isRedirect = function (e) {
      return 301 === e || 302 === e || 303 === e || 307 === e || 308 === e;
    }, V.Promise = global.Promise, t.default = V;
  }
};